class QuizIntro extends HTMLElement {
  constructor() {
    super();
    // Must match the button href and the inline script in sections/quiz-intro.liquid
    this.quizHash = '#quiz';
    this.onHashChange = () => this.sync();
    this.onSectionSelect = (e) => this.handleSectionSelect(e);
  }

  connectedCallback() {
    // quiz-section listens for Enter/Escape on document. Keep them local so
    // Enter on the button follows the link instead of advancing the hidden quiz.
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === 'Escape') {
        e.stopPropagation();
      }
    });

    if (window.Shopify && window.Shopify.designMode) {
      this.setupDesignMode();
      return;
    }

    window.addEventListener('hashchange', this.onHashChange);
    this.sync();
  }

  disconnectedCallback() {
    window.removeEventListener('hashchange', this.onHashChange);
    document.removeEventListener('shopify:section:select', this.onSectionSelect);
  }

  // Theme editor: no URL state. The button and the section selected in the sidebar decide what is shown.
  setupDesignMode() {
    const button = this.querySelector('.quiz-intro__cta');
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.setStarted(true);
      });
    }

    document.addEventListener('shopify:section:select', this.onSectionSelect);
  }

  handleSectionSelect(e) {
    if (e.target.contains(this)) {
      this.setStarted(false);
    } else if (e.target.querySelector('quiz-section')) {
      this.setStarted(true);
    }
  }

  // The URL hash is the single source of truth: #quiz shows the quiz, anything else the front page
  sync() {
    this.setStarted(window.location.hash === this.quizHash);
  }

  setStarted(started) {
    if (started === this.hasAttribute('data-started')) return;

    this.toggleAttribute('data-started', started);

    if (started) {
      this.pauseVideos();
      this.focusQuiz();
    }

    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  pauseVideos() {
    this.querySelectorAll('video-element').forEach((video) => {
      if (typeof video.pause === 'function') video.pause();
    });
  }

  focusQuiz() {
    const quiz = document.querySelector('quiz-section');
    if (!quiz) return;

    quiz.setAttribute('tabindex', '-1');
    quiz.focus({ preventScroll: true });
  }
}

window.customElements.define('quiz-intro', QuizIntro);
